function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import validate from 'validate.js';
var Validation = /*#__PURE__*/ function() {
    "use strict";
    function Validation() {
        var _this = this;
        _class_call_check(this, Validation);
        // eslint-disable-next-line no-undef
        this.schema = validationData;
        if (this.schema) {
            var _document_querySelectorAll;
            (_document_querySelectorAll = document.querySelectorAll('[data-validation]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($form) {
                var _$form_querySelectorAll;
                var $fields = $form.querySelectorAll('.field__input');
                $fields === null || $fields === void 0 ? void 0 : $fields.forEach(function($field) {
                    $field.addEventListener('input', function() {
                        setTimeout(function() {
                            _this.validate($field);
                        }, 150);
                    });
                    $field.addEventListener('blur', function() {
                        setTimeout(function() {
                            _this.validate($field);
                        }, 150);
                    });
                });
                (_$form_querySelectorAll = $form.querySelectorAll('input[type="checkbox"]')) === null || _$form_querySelectorAll === void 0 ? void 0 : _$form_querySelectorAll.forEach(function($checkbox) {
                    $checkbox.addEventListener('change', function() {
                        setTimeout(function() {
                            _this.validate($checkbox);
                        }, 150);
                    });
                });
                $form.addEventListener('submit', function(event) {
                    _this.checkAll($form, event);
                });
            });
        }
    }
    _create_class(Validation, [
        {
            key: "validate",
            value: function validate1($el) {
                var value = '';
                var $form = $el.closest('form');
                var objectItem = this.schema.find(function(item) {
                    return item.form === $form.id;
                });
                if (!(objectItem === null || objectItem === void 0 ? void 0 : objectItem.schema[$el.name])) return;
                if ($el.type === 'checkbox') {
                    if ($el.name.includes('[]')) {
                        value = $form.querySelectorAll('input[name="'.concat($el.name, '"]:checked')).length > 0;
                    } else {
                        value = $el.checked;
                    }
                } else {
                    value = $el.value;
                }
                var errors = validate.single(value, objectItem.schema[$el.name]);
                Validation.addError($el, errors);
            }
        },
        {
            key: "checkAll",
            value: function checkAll($form, event) {
                var _$form_querySelectorAll;
                event.preventDefault();
                var formErrors = false;
                var schema = this.schema.find(function(item) {
                    return item.form === $form.id;
                });
                if (!schema) return;
                (_$form_querySelectorAll = $form.querySelectorAll('input')) === null || _$form_querySelectorAll === void 0 ? void 0 : _$form_querySelectorAll.forEach(function($item) {
                    if (schema.schema[$item.name]) {
                        var value;
                        if ($item.type === 'checkbox') {
                            if ($item.name.includes('[]')) {
                                value = $form.querySelectorAll('input[name="'.concat($item.name, '"]:checked')).length > 0;
                            } else {
                                value = $item.checked;
                            }
                        } else {
                            value = $item.value;
                        }
                        var errors = validate.single(value, schema.schema[$item.name]);
                        Validation.addError($item, errors);
                        if (errors) formErrors = true;
                    }
                });
                if (!formErrors) $form.dispatchEvent(new CustomEvent('formSubmit'));
            }
        }
    ], [
        {
            key: "addError",
            value: function addError($el, errors) {
                var $form = $el.closest('form');
                var $field = $el.closest('.field');
                var $checkbox = $el.closest('.checkbox');
                var $error = $field === null || $field === void 0 ? void 0 : $field.querySelector('.field__error');
                if ($field) {
                    if (errors) {
                        $field.classList.add('field_error');
                        var _errors = _sliced_to_array(errors, 1), errorText = _errors[0];
                        if (!$error) {
                            $field.insertAdjacentHTML('beforeend', '<span class="field__error">'.concat(errorText, "</span>"));
                        } else {
                            $error.innerText = errorText;
                        }
                    } else {
                        if ($error) $error.remove();
                        $field.classList.remove('field_error');
                    }
                }
                if ($checkbox) {
                    if ($el.name.includes('[]')) {
                        var _$form_querySelectorAll;
                        (_$form_querySelectorAll = $form.querySelectorAll('input[name="'.concat($el.name, '"]'))) === null || _$form_querySelectorAll === void 0 ? void 0 : _$form_querySelectorAll.forEach(function($item) {
                            if (errors) {
                                $item.closest('.checkbox').classList.add('checkbox_error');
                            } else {
                                $item.closest('.checkbox').classList.remove('checkbox_error');
                            }
                        });
                    } else if (errors) {
                        $checkbox.classList.add('checkbox_error');
                    } else {
                        $checkbox.classList.remove('checkbox_error');
                    }
                }
            }
        }
    ]);
    return Validation;
}();
export default Validation;
